import apiClient from './apiClient';

const storiesApi = {
  getFeed: () => apiClient.get('/stories/feed').then((r) => r.data),

  getMine: () => apiClient.get('/stories/mine').then((r) => r.data),

  getUserStories: (userId: string) =>
    apiClient.get(`/stories/${userId}`).then((r) => r.data),

  create: (userId: string, formData: FormData) =>
    apiClient.post(`/stories/${userId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),

  delete: (userId: string, storyId: string) =>
    apiClient.delete(`/stories/${userId}/${storyId}`).then((r) => r.data),

  markViewed: (storyId: string) =>
    apiClient.post(`/stories/viewed/${storyId}`).then((r) => r.data),
};

export default storiesApi;
